/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import {
  SIGNUP_PARTNER_FAILURE,
  SIGNUP_PARTNER_SUCCESS,
  GET_PARTNER_SUCCESS,
  GET_PARTNER_FAILURE,
  UPDATE_PARTNER_FAILURE,
  UPDATE_PARTNER_SUCCESS,
  LIST_PARTNERS_SUCCESS,
  LIST_PARTNERS_FAILURE,
} from "../actions/actionTypes";

const initialState = {
  partner: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SIGNUP_PARTNER_SUCCESS:
      return {
        ...state.partner,
        signUpPartnerSuccess: true,
        partner: action.payload.partner,
      };

    case SIGNUP_PARTNER_FAILURE:
      return {
        ...state.partner,
        signUpPartnerSuccess: true,
        message: action.err.message,
      };

    case GET_PARTNER_SUCCESS:
      return {
        ...state.partner,
        getPartnerSuccess: true,
        partnerInfo: action.payload.partner,
      };

    case GET_PARTNER_FAILURE:
      return {
        ...state.partner,
        getPartnerSuccess: true,
        partnerInfo: null,
        message: action.err.message,
      };

    case UPDATE_PARTNER_SUCCESS:
      return {
        ...state.partner,
        updatePartnerSuccess: true,
        updatedPartner: action.payload.partner,
      };

    case UPDATE_PARTNER_FAILURE:
      return {
        ...state.partner,
        updatePartnerSuccess: false,
        message: action.err.message,
      };

    case LIST_PARTNERS_SUCCESS:
      return {
        ...state.partner,
        listPartnersSuccess: true,
        partners: action.payload.partners,
      };

    case LIST_PARTNERS_FAILURE:
      return {
        ...state.partner,
        listPartnersSuccess: true,
        partners: null,
        message: action.err.message,
      };

    default:
      return state;
  }
}
